import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Loader from '../spinner';
import css from './index.scss';
import messages from './messages';
import Button from '../button/index';
import { DENIM } from '../button/variants';
import DropDownList from '../dropdown-list/index';

const TeacherView = (props) => {
    const {
        intl,
        teachers,
        onTeacherSelection,
        isTeachersLoaded,
        selectedTeacherId,
        handleOnLaunch,
        isGettingToken,
        isFetchingData
    } = props;

    const finalView = (isTeachersLoaded)
        ? (<div className={css.container}>
            <div className={css.header}>{intl.formatMessage(messages.teacherView)}</div>
            <div className={css.teachers}>
                <DropDownList
                    name="teachers"
                    onChange={onTeacherSelection}
                    optionKey="id"
                    options={teachers}
                    optionText="name"
                    placeholder={intl.formatMessage(messages.selectTeacher)}
                />
                <div className={css.subHeader}>{intl.formatMessage(messages.teacherViewSubHeading)}</div>
                <Button
                    disabled={selectedTeacherId === '-1' || isGettingToken || isFetchingData}
                    handleOnClick={handleOnLaunch}
                    label={intl.formatMessage(messages.launch)}
                    variant={DENIM} />
            </div>
            <div className={css.header} />
        </div>) : (<div className={css.loader}>
            <Loader color="grey" size="15px" />
        </div>);

    return finalView;
};

TeacherView.propTypes = {
    intl: intlShape.isRequired,
    teachers: PropTypes.array,
    onTeacherSelection: PropTypes.func,
    isTeachersLoaded: PropTypes.bool,
    selectedTeacherId: PropTypes.string,
    handleOnLaunch: PropTypes.func,
    isGettingToken: PropTypes.bool,
    isFetchingData: PropTypes.bool
};

export default injectIntl(styleable(css)(TeacherView));




// WEBPACK FOOTER //
// ./app/components/teacher-view/index.js